export default __webpack_public_path__ + "static/8-7bca53e7d5840a7ab697fe083061dc9a.jpg";